export default __webpack_public_path__ + "media/images/menu_arrow-ee77c2226ce69e13c7bf7d67f3e086e7.png";